<h2>{{title}}</h2>
<table>
<tr>
<td></td>
{{#categories}}
<td>{{.}}</td>
{{/categories}}
</tr>
{{#series}}
<tr>
  <td>{{name}}</td>
  {{#data}}
    <td>{{.}}</td>
  {{/data}}
</tr>
{{/series}}
</table>
